import { useInsertionEffect } from "react";

const buildCss = (wrapperClassName: string) => `
  [data-surface-action] {
    position: relative;
    z-index: 2;
    pointer-events: auto;
  }
  .${wrapperClassName} tbody tr[data-row-link] {
    position: relative;
    cursor: pointer;
  }
  .${wrapperClassName} tbody tr[data-row-link]:hover td {
    background: #f8fafc;
  }
  .${wrapperClassName} tbody tr[data-row-link] td[data-row-link-host] {
    position: relative;
    overflow: visible;
  }
  .${wrapperClassName} tbody tr[data-row-link] td[data-action-cell] {
    position: relative;
    z-index: 2;
  }
  /* Mouse only: pass clicks through cells to the row-spanning overlay link. */
  @media (hover: hover) and (pointer: fine) {
    .${wrapperClassName} tbody tr[data-row-link] td:not([data-action-cell]) {
      pointer-events: none;
    }
    .${wrapperClassName} tbody tr[data-row-link] td:not([data-action-cell]) > * {
      pointer-events: none;
    }
  }
  .${wrapperClassName} tbody tr[data-row-link] .gt-row-link-overlay {
    pointer-events: auto;
    touch-action: manipulation;
  }
`;

/**
 * Shared CSS for table row links and card surface links (`data-surface-action`).
 *
 * Injected into `document.head` (idempotently, per wrapper class) so it persists
 * across route changes. A previous implementation rendered the `<style>` inline and
 * guarded it with a module-level flag; once the hosting component unmounted on
 * navigation the CSS was removed and never re-added, which let clicks on action
 * buttons fall through to the card's surface link overlay.
 */
export default function TableRowLinkTableStyles({
  wrapperClassName = "gt-table-row-link",
}: {
  wrapperClassName?: string;
}) {
  useInsertionEffect(() => {
    if (typeof document === "undefined") return;
    const styleId = `gt-table-row-link-styles-${wrapperClassName}`;
    if (document.getElementById(styleId)) return;
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = buildCss(wrapperClassName);
    document.head.appendChild(style);
  }, [wrapperClassName]);

  return null;
}
